import { Icon, type IconProps } from "@chakra-ui/react";

const BrandAlertIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 11 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0ZM6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V5.5C5 5.77614 5.22386 6 5.5 6C5.77614 6 6 5.77614 6 5.5V3.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H5.505C5.78114 8 6.005 7.77614 6.005 7.5C6.005 7.22386 5.78114 7 5.505 7H5.5Z"
				fill="currentColor"
			/>
		</Icon>
	);
};

export default BrandAlertIcon;
